import { Component, OnInit } from '@angular/core'
import { MdDialogRef } from '@angular/material'

import { ShareProvider } from '../../social-share/social-share.module'

import { Angulartics2 } from 'angulartics2'

@Component({
  selector: 'cm-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.css']
})
export class ShareDialogComponent implements OnInit {

  constructor(private dialogRef: MdDialogRef<ShareDialogComponent>,
    private angulartics2: Angulartics2) { }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close()
  }

  onPopUpClosed(provider: ShareProvider) {
    const name = ShareProvider.toString(provider)
    this.angulartics2.eventTrack.next({ action: `${name}_share`, properties: { category: 'social' }})
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/share-dialog/share-dialog.component.ts